import React from 'react';
import { Input as RInput, Spinner } from 'reactstrap';

import './styles.scss';
import searchIcon from '../../assets/search-icon.svg';
import '../FormComponents/styles.scss';

const Input = ({ ...rest }) => <input className="input-custom-s" {...rest} />;

const Label = ({ className, children, fullWidth, ...rest }) => (
  <label className={`label-custom-s ${fullWidth ? 'full-width' : ''} ${className}`} {...rest}>
    {children}
  </label>
);

const SearchInput = ({ value, onChange, placeholder, labelText, fullWidth, icon, isLoading, ...rest }) => (
  <Label fullWidth={fullWidth}>
    {labelText}
    <RInput
      className="styled-inputs"
      type="text"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      {...rest}
    />
    {isLoading ? (
      <Spinner className="search-spinner-input" animation="border" />
    ) : (
      <img {...(icon ? { ...icon } : { src: searchIcon, alt: '' })} alt={icon?.alt || ''} />
    )}
  </Label>
);

export { Input, Label };

export default SearchInput;
